// src/components/block/liveStreamManagment/VuUnitToggle.tsx
//
// Commutateur de l'unité de TOUS les VU-mètres de la régie (deck, mixeur, réglage
// des sources), mémorisée dans ce navigateur : dBFS crête (saturation) ou LUFS
// (volume perçu, EBU R128 Momentary, cible −14).
//
// Placé le 2026-11-03 dans l'en-tête du panneau « Mixeur » du deck, à droite du
// haut-parleur d'écoute — il était dans le bloc Switch audio de la barre.

import React from 'react';
import { LUFS_TARGET, setVuMeterMode, useVuMeterMode } from './vuMeterZones';

const OPTIONS = [
  ['peak', 'dBFS', 'dBFS crête : le pic du signal, pour éviter la saturation (rouge au-delà de 0)'],
  ['lufs', 'LUFS', `LUFS : le volume perçu (EBU R128, 400 ms), autour de la cible ${LUFS_TARGET} LUFS du streaming`],
] as const;

const VuUnitToggle: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const vuMode = useVuMeterMode();
  return (
    <div
      role="radiogroup"
      aria-label="Unité des VU-mètres"
      style={{
        display: 'flex', height: compact ? 16 : 36, borderRadius: compact ? 4 : 6, overflow: 'hidden',
        border: '1px solid rgba(255,255,255,0.15)', flexShrink: 0,
      }}
    >
      {OPTIONS.map(([m, label, tip]) => (
        <button
          key={m} type="button" role="radio" aria-checked={vuMode === m} title={tip}
          onClick={() => setVuMeterMode(m)}
          style={{
            padding: compact ? '0 5px' : '0 10px', fontSize: compact ? 9 : 12, fontWeight: 700, lineHeight: 1,
            border: 'none', cursor: 'pointer',
            background: vuMode === m ? '#25C400' : 'rgba(255,255,255,0.05)',
            color:      vuMode === m ? '#0f172a' : 'rgba(255,255,255,0.7)',
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default VuUnitToggle;
